module.exports = __webpack_public_path__ + "static/media/signature.a8951538.png";